
import { createRoot } from 'react-dom/client';
import React from 'react'; // Explicitly import React
import App from './App.tsx';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/auth/AuthProvider';

// Extend Window interface for custom properties
declare global {
  interface Window {
    updateDocumentTitle: (title: string) => void;
    LOVABLE_HIDE_BADGE: boolean;
  }
}

// Set default document title
document.title = 'ProptPilot - Property Management Made Simple';

// Dynamic title management
const updateDocumentTitle = (title: string) => {
  document.title = title;
};

// Make it available globally
window.updateDocumentTitle = updateDocumentTitle;

// Add badge hiding parameter to window
window.LOVABLE_HIDE_BADGE = true;

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
